import { api } from '@/services/api';
import { rootReducer } from '@/store/rootReducer';
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(api.middleware)
});

export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;
export const useAppDispatch: () => AppDispatch = useDispatch;

if (import.meta.hot) {
  import.meta.hot.accept('./rootReducer', (newModule) => {
    store.replaceReducer(newModule?.rootReducer);
  });
}
